import RelationsService from '@/services/relations.service';

import {
  FETCH_RELATIONS,
  FIND_RELATION,
  DELETE_RELATION,
  DELETE_CHILDREN_RELATION,
  CREATE_RELATION,
  CLEAR_RELATIONS,
  UPDATE_RELATION,
  CREATE_SCENE_DICT,
} from './relations.actions.types';
import { SET_RELATIONS, SET_RELATION, SET_ERROR } from './relations.mutations.types';

const state = {
  error: null,
  relations: [],
};

const actions = {
  async [FETCH_RELATIONS]({ commit }, params) {
    try {
      const relations = await RelationsService.fetchRelations({
        ...params,
      });

      commit(SET_RELATIONS, relations.docs);
    } catch (error) {
      commit(SET_ERROR, error);
    }
  },
  async [FIND_RELATION]({ commit }, id) {
    try {
      const data = await RelationsService.findRelation(id);
      commit(SET_RELATIONS, data || []);
      return data;
    } catch (error) {
      console.log(error);
    }
  },
  async [DELETE_RELATION]({ commit }, id) {
    try {
      await RelationsService.deleteRelation(id);

      commit(DELETE_RELATION, id);
    } catch (error) {
      commit(SET_ERROR, error);
    }
  },
  async [DELETE_CHILDREN_RELATION]({ commit }, id) {
    try {
      await RelationsService.deleteChildrenRelation(id);

      commit(DELETE_CHILDREN_RELATION, id);
    } catch (error) {
      commit(SET_ERROR, error);
    }
  },
  async [CREATE_SCENE_DICT]({ commit }, { sceneJson, resourceId }) {
    try {
      const relations = Object.values(sceneJson)
        .filter((cont) => cont.userData && (cont.userData.resourceId || cont.userData.imageId))
        .map(
          (sceneResource) => sceneResource.userData.resourceId || sceneResource.userData.imageId
        );
      await RelationsService.generateSceneDict(resourceId, relations);
    } catch (error) {
      console.log(error);
      commit(SET_ERROR, error);
    }
  },
  async [UPDATE_RELATION]({ commit }, relation) {
    try {
      await RelationsService.updateRelation({
        id: relation.id,
        relation,
      });
    } catch (error) {
      console.log(error);
      commit(SET_ERROR, error);
    }
  },
  async [CLEAR_RELATIONS]({ commit }) {
    commit(SET_RELATIONS, []);
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.error = error;
  },
  [SET_RELATIONS](state, relations) {
    state.relations = relations;
    state.error = null;
  },
  [SET_RELATION](state, relation) {
    state.relation = relation;
    state.error = null;
  },
  [DELETE_RELATION](state, id) {
    const index = state.relations.findIndex((item) => item.id === id);
    state.relations.splice(index, 1);
    state.error = null;
  },
  [DELETE_CHILDREN_RELATION](state, id) {
    const index = state.relations.findIndex((item) => item.id === id);
    state.relations.splice(index, 1);
    state.error = null;
  },
  [CREATE_RELATION](state, relation) {
    state.relations = [...state.relations, relation];
    state.error = null;
  },
};

const getters = {
  getRelations: (state) => () => state.relations,
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
